import { CacheProvider } from '@emotion/react';

import { IslandUiProvider } from '../../../shared/islands/island-ui-provider.jsx';
import { createIslandEmotionCache } from '../../../shared/islands/create-island-emotion-cache.js';

// One shared cache for every client island mount (Emotion's intended pattern); per-element styles
// are deduped by content hash, so multiple instances with different state never collide.
const cache = createIslandEmotionCache();

/**
 * Client hydration tree matching SSR (`shared/islands/render-island-tree.mjs`).
 * @param {import('react').CreateElement} createElement
 * @param {import('react').ComponentType<Record<string, unknown>>} Component
 * @param {Record<string, unknown>} props
 * @param {Element} islandRootElement
 * @returns {import('react').ReactElement}
 */
export function wrapIslandTree(createElement, Component, props, islandRootElement) {
	return createElement(
		CacheProvider,
		{ value: cache },
		createElement(
			IslandUiProvider,
			{ islandRootElement },
			createElement(Component, props),
		),
	);
}
